import { render, staticRenderFns } from "./corporateOverview.vue?vue&type=template&id=e08f4a90&scoped=true"
import script from "./corporateOverview.vue?vue&type=script&lang=js"
export * from "./corporateOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08f4a90",
  null
  
)

export default component.exports